import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PlanInputs } from 'src/app/models/plan-inputs';
import {
  formatterDollar,
  formatterPercent,
  parserDollar,
  parserPercent,
} from 'src/app/utils/app-common';

@Component({
  selector: 'app-step-lending-settings',
  templateUrl: './step-lending-settings.component.html',
  styleUrls: ['./step-lending-settings.component.scss'],
})
export class StepLendingSettingsComponent implements OnInit {
  @Input() inputs!: PlanInputs;
  @Output() validityChange = new EventEmitter<boolean>();

  formatterDollar = formatterDollar;
  parserDollar = parserDollar;
  formatterPercent = formatterPercent;
  parserPercent = parserPercent;

  constructor() {}

  ngOnInit(): void {
    this.validityChange.emit(true);
  }

  handleDataChange() {}
}
